export const PLANS_TYPES = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  SDOT: 'sdot',
}